import React from "react";

const EditIcon = (props) => {
  return (
    <svg
      style={{ marginRight: 15 }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0199 0.97998C13.9516 1.91162 13.9516 3.42211 13.0199 4.35375L5.04108 12.3327C4.85649 12.5172 4.62693 12.6505 4.37509 12.7191L0.964629 13.6493C0.591383 13.7511 0.248896 13.4085 0.350689 13.0353L1.28082 9.62487C1.3495 9.373 1.48272 9.14347 1.6673 8.95887L9.6462 0.97998C10.5778 0.04834 12.0883 0.04834 13.0199 0.97998ZM8.99987 3.04059L2.37441 9.666C2.31288 9.72753 2.26848 9.804 2.24558 9.888L1.54568 12.4543L4.11198 11.7543C4.19592 11.7315 4.27244 11.6871 4.33397 11.6255L10.9592 4.99992L8.99987 3.04059ZM10.3533 1.68709L9.70654 2.33325L11.6659 4.29325L12.3129 3.64665C12.8539 3.10553 12.8539 2.22821 12.3129 1.68709C11.7717 1.14597 10.8944 1.14597 10.3533 1.68709Z"
        fill="#212121"
      />
    </svg>
  );
};

export default EditIcon;
